"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRemoteCqInvoker = void 0;
const RemoteCqInvoker_1 = require("./RemoteCqInvoker");
const command_1 = require("./command");
const RpcRequest_1 = require("./RpcRequest");
const query_1 = require("./query");
class HttpRemoteCqInvoker {
    constructor(options) {
        const commandInvoker = new command_1.HttpRemoteCommandInvoker({
            protocol: RpcRequest_1.RequestProtocol.Http,
            getConfig(settings) {
                return Promise.resolve({
                    url: `${options.baseUrl}/c`,
                    formDataSerializer: options.formDataSerializer,
                    verb: "POST",
                });
            },
        }, options.axiosInstance, options.ambientValueInjector);
        const queryInvoker = new query_1.HttpRemoteQueryInvoker({
            protocol: RpcRequest_1.RequestProtocol.Http,
            getConfig(settings) {
                return Promise.resolve({
                    url: `${options.baseUrl}/q`,
                    verb: options.useGetMethodForQueries ? "GET" : "POST",
                });
            },
        }, options.axiosInstance, options.ambientValueInjector);
        this.invoker = new RemoteCqInvoker_1.RemoteCqInvoker(commandInvoker, queryInvoker);
    }
    invokeResult(invocationClass, invocationData, invokingContext) {
        return this.invoker.invokeResult(invocationClass, invocationData, invokingContext);
    }
    /**
     * Execute method is a higher API method for invoking remote HTTP commands or queries that will:
     * - Raise an exception on request or execution failures
     * - Raise an exception if the given command is not valid
     * - Return the ExecutionResult instead of the InvocationResult
     * @param type The command class
     * @param data The command data
     * @param context The invoking context
     */
    invoke(type, data, context) {
        return this.invoker.invoke(type, data, context);
    }
}
exports.HttpRemoteCqInvoker = HttpRemoteCqInvoker;
//# sourceMappingURL=HttpRemoteCqInvoker.js.map